// extracted by mini-css-extract-plugin
module.exports = {"sv5njl":"sv5njl","s1sa9xwn":"s1sa9xwn"};